/**
 * Base URL for Flightdeck
 */
export const FLIGHTDECK_BASE_URL = 'https://app.flightdeck.cio.host';

/**
 * Builds a link to Flightdeck's masq access request page that auto-opens the request
 * modal pre-filled for the given account. Flightdeck's MasqAccessTrackingPage reads the
 * `masq_account_id` query param to open + pre-fill the modal.
 */
export function buildFlightdeckMasqAccessRequestUrl(accountId: number): string {
  return `${FLIGHTDECK_BASE_URL}/admin/masq-access?masq_account_id=${accountId}`;
}
